<template>
  <div
    v-if="horsLigne"
    class="hors-ligne"
    role="alertdialog"
    aria-live="assertive"
  >
    <PageErreurMinerve :erreur="ERREUR_HORS_LIGNE">
      <template #actions>
        <button v-focus class="btn-primary" @click="reessayer">
          {{ ERREUR_HORS_LIGNE.cta }}
        </button>
      </template>
    </PageErreurMinerve>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from "vue";
import PageErreurMinerve from "./PageErreurMinerve.vue";
import { ERREUR_HORS_LIGNE } from "./erreursMinerve";

/**
 * Écran « Connexion perdue » de la charte (section 07). Il suit les événements `online` et
 * `offline` du navigateur : il apparaît quand la connexion tombe, disparaît quand elle revient.
 * « Réessayer » relit l'état réel du navigateur.
 */
const horsLigne = ref(typeof navigator !== "undefined" && !navigator.onLine);

const quandHorsLigne = () => {
  horsLigne.value = true;
};
const quandEnLigne = () => {
  horsLigne.value = false;
};
const reessayer = () => {
  horsLigne.value = !navigator.onLine;
};

onMounted(() => {
  window.addEventListener("offline", quandHorsLigne);
  window.addEventListener("online", quandEnLigne);
});
onBeforeUnmount(() => {
  window.removeEventListener("offline", quandHorsLigne);
  window.removeEventListener("online", quandEnLigne);
});
</script>

<style scoped>
.hors-ligne {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  background: var(--clr-n1, #fff);
}
</style>
